import styled from "styled-components";

const Wrapper = styled.div`
  height: 80px;
  box-shadow: var(--shadow-sm);
  z-index: 999;
  background: rgba(249, 247, 242, 0.85); /* Glassmorphism Base */
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  position: sticky;
  top: 0;
  left: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);

  .container {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 100%;

    @media (max-width: 960px) {
      padding: 0 20px;
    }
  }

  .logo-link {
    display: flex;
    align-items: center;
    gap: 15px;
    cursor: pointer;
    text-decoration: none;
  }

  .logo-img {
    object-fit: contain;
    width: 55px;
    height: 55px;
    filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));
    
    @media (max-width: 960px) {
      width: 45px;
      height: 45px;
    }
  }

  .left {
    .logo {
      color: var(--primary-color);
      font-family: 'Playfair Display', serif;
      font-size: 1.6rem;
      margin: 0;
      line-height: 1;
      font-weight: 700;
      letter-spacing: -0.5px;

      @media (max-width: 450px) {
        font-size: 1.2rem;
      }

      span {
        color: var(--secondary-color); /* Gold accent */
        font-style: italic;
      }
    }
  }

  .right {
    @media (max-width: 960px) {
      position: absolute;
      z-index: 10000;
      top: -1000%;
      left: 0;
      right: 0;
      opacity: 0;
      background: var(--primary-color); /* Deep Navy Background */
      height: 100vh;
      display: flex; /* Center items on mobile */
      justify-content: center;
      padding-top: 100px;
      transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);

      &.active {
        opacity: 1;
        top: 0;
      }
    }
    .navbar {
      display: flex;
      align-items: center;
      gap: 30px;

      @media (max-width: 960px) {
        flex-direction: column;
        gap: 40px;
      }

      li {
        font-size: 1.1rem;
        font-weight: 500;
        color: var(--primary-color);
        cursor: pointer;
        position: relative;
        font-family: 'Lato', sans-serif;

        &::after {
          content: '';
          position: absolute;
          width: 0;
          height: 2px;
          bottom: -5px;
          left: 0;
          background-color: var(--secondary-color);
          transition: width 0.3s ease;
        }

        &:hover::after, .activeLink::after {
          width: 100%;
        }

        .activeLink {
          color: var(--primary-color);
          font-weight: 700;
        }

        @media (max-width: 960px) {
          font-size: 1.8rem;
          color: #f9f9f9;
          font-family: 'Playfair Display', serif;
          
          .activeLink {
             color: var(--secondary-color);
          }
        }
      }

      .btn {
        padding: 10px 25px;
        font-size: 1rem;
        
        @media (max-width: 960px) {
          background-color: var(--secondary-color);
          color: var(--primary-color);
          padding: 15px 40px;
          font-size: 1.4rem;
          margin-top: 20px;
          
          &:hover {
             background-color: #fff;
          }
        }
      }
    }
  }

  .burger {
    display: none;
    z-index: 10001; /* Ensure above mobile menu bg */
    
    @media (max-width: 960px) {
      display: block;
    }

    .burger-icon {
      font-size: 2rem;
      color: var(--primary-color);
      cursor: pointer;
      transition: color 0.3s;
      
      /* If menu is open (we might need to pass a prop or class to change color to white if bg is dark) - simplest is to keep it variable */
    }
  }
`;

export default Wrapper;
